import { IArithmeticalEvaluation } from "../../../interfaces/Rights";
import ArithmeticalEvaluation from "../../Evaluations/ArithmeticalEvaluation";

const HeaderEvaluation = ({ arithmeticalEvaluation }: { arithmeticalEvaluation: IArithmeticalEvaluation[] }) => (
    <div className="border rounded-sm border-[#8A9296] w-full md:w-[25rem] h-[5rem] mt-4 bg-system-light-10">
        <ArithmeticalEvaluation
            data={arithmeticalEvaluation}
            showIndicators
            label="Cantidad de indicadores por estado evaluados"
            backgroundColor="bg-brand-green-1"
            classNameLabel="text-bsmall md:text-bmedium text-brand-green-15"
        />
    </div>
);

export default HeaderEvaluation